<template>
    <div class="box m-b-0">
        <div class="box-header">
            <h3>Nowy pokój</h3>
        </div>
        <div class="box-tool">
            <ul class="nav">
                <li class="nav-item inline icon-with-desc">
                    <a class="nav-link text-muted" @click="$emit('close')">
                        <i class="material-icons md-18">clear</i>
                        <span class="icon-desc">ESC</span>
                    </a>
                </li>
            </ul>
        </div>
        <hr class="m-y-0"/>
        <div class="box-body">
            <div class="form-group">
                <label>Nazwa pokoju</label>
                <input type="text" class="form-control" v-model="name" maxlength="60" placeholder="np. projekt-hala2" @keyup.enter="create"/>
            </div>
            <div class="form-group">
                <label>Uczestnicy</label>
                <input type="text" class="form-control m-b-xs" v-model="filter" placeholder="Szukaj..."/>
                <div class="chat-user-picker">
                    <label class="chat-user-option" v-for="user in filteredUsers" :key="user._id">
                        <input type="checkbox" :value="String(user._id)" v-model="selected"/>
                        <span class="m-l-xs">{{ user.name }}</span>
                    </label>
                </div>
            </div>
            <button class="btn blue none-radius" :disabled="!name.trim() || isSaving" @click="create">Utwórz pokój</button>
        </div>
    </div>
</template>

<script>
import ChatManager from '../../ChatManager.js';
import SystemUsersManager from '../../SystemUsersManager.js';

export default {
    name: 'ChatCreateRoomModal',
    data: function() {
        return {
            name: '',
            filter: '',
            selected: [],
            systemUsers: [],
            isSaving: false,
        };
    },
    created: async function() {
        this.systemUsers = await SystemUsersManager.getSystemUsers();
    },
    computed: {
        filteredUsers: function() {
            const me = String(ChatManager.getMyUserId());
            const q = this.filter.toLowerCase();
            return (this.systemUsers || [])
                .filter(u => String(u._id) != me && !u.isRemoved && !u.isDisabled)
                .filter(u => !q || (u.name || '').toLowerCase().includes(q))
                .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }
    },
    methods: {
        create: async function() {
            if (!this.name.trim() || this.isSaving) return;
            this.isSaving = true;
            try {
                const room = await ChatManager.createRoom(this.name.trim(), this.selected);
                this.$emit('close');
                ChatManager.openRoom(room._id);
            } catch (e) {
                this.$h.commonApiError(e);
            } finally {
                this.isSaving = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.chat-user-picker {
    max-height: 220px;
    overflow-y: auto;
    border: 1px solid var(--dm-border, #e9ecef);
    border-radius: 4px;
    padding: 6px 10px;
}

.chat-user-option {
    display: block;
    margin: 0;
    padding: 3px 0;
    font-weight: 400;
    cursor: pointer;
}
</style>
